import { cn } from '../../lib/utils';

interface AnswerContainerProps {
  children: React.ReactNode;
  className?: string;
}

function AnswerContainer(props: AnswerContainerProps) {
  return (
    <div
      className={cn(
        'answer-message-container w-full sm:w-4/5 text-[0.95rem] self-start relative bg-white text-slate-800 ml-0 sm:ml-1 mb-4 px-4 py-3 rounded-2xl border border-slate-200/70 shadow-[0_10px_25px_rgba(15,23,42,0.06)] animate-enter',
        props.className
      )}
    >
      {props.children}
    </div>
  );
}

export default AnswerContainer;
